const API_BASE_URL = 'https://visual-product-matcher-uqlo.onrender.com';


export default API_BASE_URL;